import { FaClock, FaMapMarkerAlt, FaCalendarAlt } from 'react-icons/fa';
import { GiDress } from "react-icons/gi";
import { BiDrink } from "react-icons/bi";

import barraca from '../assets/images/barraca.jpg';

const EventDetail = () => {
  const events = [
    {
      title: "Pre-boda",
      date: "Viernes, 11 de Septiembre 2026",
      time: "18:00 - 23:00",
      location: <a href="https://maps.app.goo.gl/n48xNet5GmP92F9NA" target="_blank">Villamarchante, Valencia</a>,
      dressCode: 'Guapitos para cena. Smart casual. Bañador',
      description: 'Cocktail / cena informal, cervezas, piscina y buen ambiente',
      map: <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d60130.45736893532!2d-0.5553039000604415!3d39.52904355297306!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd60f5df083ead0d%3A0x8bf3401005fca039!2s46191%20Vilamarxant%2C%20Valencia!5e0!3m2!1ses!2ses!4v1768160695238!5m2!1ses!2ses"
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen 
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
    },
    {
      title: "Boda",
      date: "Sábado, 12 de Septiembre 2026",
      time: "12:00 - 00:00",
      location: <a href="https://maps.app.goo.gl/cNHnwUdNAZamo2rA6" target="_blank">La albufera, Valencia</a>,
      dressCode: 'Boda de verano: Elegante pero relajado',
      description: 'Ceremonia y boda de día',
      map: <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3086.811915234699!2d-0.32175612372654644!3d39.31518672194441!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd61b58b3d1a4001%3A0xeff8f1d74ac00167!2sLa%20Barraca%20del%20Palmar%20by%20Grupo%20El%20Alto!5e0!3m2!1ses!2ses!4v1768148332340!5m2!1ses!2ses" 
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen 
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
    },
    {
      title: "Brunch",
      date: "Domingo, 13 de Septiembre 2026",
      time: "12:00 - 16:00",
      location: <a href="https://maps.app.goo.gl/1nn3qT73D6FGrA1F6" target="_blank">Valencia</a>,
      dressCode: 'Informal',
      description: 'Brunch con vistas al mar',
      additionalMapNotes: <p>Pendiente de concretar. ¡Estad atentos!. <br></br> Una cosa es segura, será en Valencia!</p>,
      map: <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d98646.97135785416!2d-0.4439118977378858!3d39.407888824877354!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd604f4cf0efb06f%3A0xb4a351011f7f1d39!2sValencia!5e0!3m2!1ses!2ses!4v1768148657166!5m2!1ses!2ses"
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen 
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
    }
  ];

  const mapInitOpts = {
    center: {
      lat: 10.99835602,
      lng: 77.01502627
    },
    zoom: 11
  };

  return (
    <section className="py-16 px-4 bg-rose-50" id="event-details">
      <div className="max-w-4md max-w-6xl mx-auto">
        <h2 className="font-great-vibes text-4xl text-center text-rose-600 mb-12">Timeline del fin de semana</h2>
        
        <img src={barraca} className="opacity-90 rounded-md md:max-w-[400px] m-auto mt-4 mb-12" />
        
        <div className="grid md:grid-cols-1 lg:grid-cols-3 gap-6">
          {events.map((event, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <h3 className="text-xl font-semibold text-rose-600 mb-4">{event.title}</h3>
              
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <FaCalendarAlt className="text-rose-400 mt-1 flex-shrink-0" />
                  <p>{event.date}</p>
                </div>
                
                <div className="flex items-start gap-3">
                  <FaClock className="text-rose-400 mt-1 flex-shrink-0" />
                  <p>{event.time}</p>
                </div>

                <div className="flex items-start gap-3">
                  <BiDrink className="text-rose-400 mt-1 flex-shrink-0" />
                  <p>{event.description}</p>
                </div>
                
                <div className="flex items-start gap-3">
                  <GiDress alt="Código de vestimenta" className="text-rose-400 mt-1 flex-shrink-0" styles={{ width: '20px' }} />
                  <p>{event.dressCode}</p>
                </div>
                
                <div className="flex items-start gap-3">
                  <FaMapMarkerAlt className="text-rose-400 mt-1 flex-shrink-0" />
                  <p>{event.location}</p>
                </div>
              </div>
              

              <div className="h-64 w-full bg-gray-200 rounded-lg overflow-hidden mt-10">
                { event.map }
              </div>

              { event.additionalMapNotes ? (
                <div className="text-m font-semibold text-rose-400 mt-5 mb-2">
                  { event.additionalMapNotes }
                </div>
              )
               : undefined }
              {/* <button className="mt-6 px-4 py-2 bg-rose-600 text-white rounded-full hover:bg-rose-700 transition-all flex items-center gap-2 mx-auto cursor-pointer">
                <FaMapMarkerAlt /> Ver ubicación
                </button> */}
            </div>
          ))}
        </div>
        
        {/* <div className="mt-12 bg-white p-6 rounded-lg shadow-md">
          <div className="h-64 w-full bg-gray-200 rounded-lg overflow-hidden">
            <iframe 
            title="Lokasi Pernikahan"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3944.028920711012!2d115.25972231533865!3d-8.733752393758266!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd246bc8b3b08a5%3A0x4c1e3b0d5b9d5b1f!2sUbud%2C%20Gianyar%2C%20Bali!5e0!3m2!1sen!2sid!4v1620000000000!5m2!1sen!2sid" 
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen 
              loading="lazy"
            ></iframe>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default EventDetail;